import { storeIcons } from "constants/storeIcons";

export function getStoreIcon(storeName: string) {
  switch (storeName) {
    case "spotify":
      return storeIcons.spotify;
    case "Apple Music":
      return storeIcons.appleMusic;
    case "appleMusic":
      return storeIcons.appleMusic;
    case "YouTube Music":
      return storeIcons.youtubeMusic;
    case "youtube":
      return storeIcons.youtubeMusic;
    case "deezer":
      return storeIcons.deezer;
    case "Tidal":
      return storeIcons.tidal;
    case "audiomack":
      return storeIcons.audiomack;
    case "iHeart Radio":
      return storeIcons.iHeartRadio;
    case "iTunes":
      return storeIcons.iTunes;
    case "Amazon Music":
      return storeIcons.amazonMusic;
    case "VEVO":
      return storeIcons.vevo;
    default:
      return "";
  }
}
